// Copyright 2005-2014 David Caldwell <david@porkrind.org> All rights reserved.

var Login = require('./login');
var lib = require('./lib'), merge=lib.merge, map_obj=lib.map_obj;
var ajax = require('./ajax'), loadJSON=ajax.loadJSON, postJSON=ajax.postJSON, makeurl=ajax.makeurl;
var print = require('./print'), printf=print.printf;
var dom = require('./dom'), doc=dom.doc, Cookie=dom.Cookie;
var debug = require('./debug'), try_report=debug.try_report, bug=debug.bug, report_error=debug.report_error;

class persistent_queue {
    constructor(name, kb_limit) {
        this.kb_limit = kb_limit;
        this.name = name;
        this.key = "queue_"+name;
        this.q = [];
        this.restore();
    }
    save(ret) {
            try {
                if (!localStorage) return ret;
            } catch(e) {
                return ret;
            }
            let shortq = [].concat(this.q);
            for (var json; (json = JSON.stringify(shortq)).length > this.kb_limit*1024;)
                shortq.shift();
            try {
                localStorage.setItem(this.key, json);
            } catch(e) {
                // safari thows "QuotaExceededError: DOM Exception 22" on .setItem when private browsing (https://stackoverflow.com/questions/21159301/quotaexceedederror-dom-exception-22-an-attempt-was-made-to-add-something-to-st#23453866)
                if (e.code != 22) report_error("persistent_queue-"+this.name+"-save-setItem", e, { shortq:shortq });
            }
            return ret;
    }

    restore() {
            try {
                if (!localStorage) return;
            } catch(e) {
                return;
            }
            var data;
            try_report(() => {
                data = localStorage.getItem(this.key);
            }, "persistent_queue-"+this.name+"-restore-getItem", { key:this.key });
            if (data != null)
                try_report(() => {
                    let d = JSON.parse(data);
                    if (d.constructor != Array) throw new Error("wrong type for queue");
                    this.q = d;
                }, "persistent_queue-"+this.name+"-restore-parse", { key:this.key, data:data });
    }

    push(data)    { return this.save(this.q.push(data)) }
    pop()         { return this.save(this.q.pop()) }
    shift()       { return this.save(this.q.shift()) }
    unshift(data) { return this.save(this.q.unshift(data)) }
}

class stats {
  constructor(game) {
    this.game = game;
    this.queue = [];
    this.anonymous_queue = new persistent_queue("anonymous_plays", 200);
    this.sent = [];
    this.pending_stats = doc.text("");
    doc.id("pending_stats").appendChild(this.pending_stats);
    doc.id("pending").onclick = function () { this.send_queued(); }.bind(this);
    this.pending = doc.id("pending");
    this.el = doc.id("stats");

    if (Login) Login.on_login(function() { this.send_queued() }.bind(this));
  }

    start() {
        this.done();
        this.current = { "name": this.game, "start date": Date.now(), start_timestamp: window.performance.now() };
    }

    cancel() {
        delete this.current;
    }

    started() {
        return this.current && !this.current._done;
    }

    pause() {
        if (this.current && !this.current._pause) {
            this.current._pause = window.performance.now();
            this.inc('pause_count');
        }
    }

    unpause() {
        if (this.current && this.current._pause) {
            this.inc("pause", window.performance.now() - this.current._pause);
            delete this.current._pause;
            this.inc('unpause_count');
        }
    }

    done(callback) {
        if (!this.current) return;
        if (!this.current._done) {
            this.unpause();
            this.current["end date"] = Date.now();
            this.current.end_timestamp = window.performance.now();
            this.current._callback = callback;
            this.current._done = true;
            this.send(this.current);
        } else if (callback) {
            // This strange case happens if you undo your last move and then do it again. Only do the callback if
            // we've got our play_id back by now.
            if (this.current._play_id)
                callback(this.current._play_id);
        }
        this.current = undefined;
    }

    set(stat, val) {
        if (!this.current) return;
        return this.current[stat] = val;
    }

    inc(stat, inc) {
        if (!this.current) return;
        if (inc == undefined) inc = 1;
        if (this.current[stat] == undefined) this.current[stat] = 0;
        return this.current[stat] += inc;
    }

    dec(stat, dec) {
        if (!this.current) return;
        if (dec == undefined) dec = 1;
        if (this.current[stat] == undefined) this.current[stat] = 0;
        return this.current[stat] -= dec;
    }

    max(stat, val) {
        if (!this.current) return;
        if (this.current[stat] == undefined)
            return this.current[stat] = val;
        return this.current[stat] = Math.max(this.current[stat], val);
    }

    min(stat, val) {
        if (!this.current) return;
        if (this.current[stat] == undefined)
            return this.current[stat] = val;
        return this.current[stat] = Math.min(this.current[stat], val);
    }

    push(stat, val) {
        if (!this.current) return;
        if (this.current[stat] == undefined)
            this.current[stat] = [];
        return this.current[stat].push(val);
    }

    save() {
        this.push("save_restore", { save_date: Date.now(), // Not used but seems useful for debugging
                                    save_timestamp: window.performance.now(),
                                    start_timestamp: this.current.start_timestamp }); // start_timestamp is redundant to save, but we do it so we have the history.
        return { ...this.current };
    }

    restore(saved) {
        if (!saved.save_restore || saved.save_restore.length < 1) // Should never happen??
            return;
        this.current = { ...saved };
        let save = this.current.save_restore[this.current.save_restore.length - 1];
        save.restore_date = Date.now(); // Not used (like save_date) but nice when debugging
        this.inc("restore_count");
        // The monotonic timer's origin is not consistent across page loads. So we fake our start to match
        // the current elapsed time (which we compute from what we saved in save())
        this.current.start_timestamp = window.performance.now() - (save.save_timestamp - save.start_timestamp);
    }

    send(data) {
        this.queue.push(data);
        this.update_status();
        this.send_queued();
    }
    update_status () {
        if (this.queue.length) {
            this.el.classList.add("pending");
            this.pending.title = this.queue.length + " game"+(this.queue.length>1?"s":"")+" are waiting to be sent.  Click to send immediately.";
            this.pending_stats.data = this.queue.length;
        } else {
            this.el.classList.remove("pending");
            this.pending_stats.data = "";
        }
    }
    fix() {
        if (this.outstanding) {
            this.sending = false;
            this.queue.unshift(this.outstanding);
            this.outstanding.fixed = (this.outstanding.fixed || 0) + 1;
            delete this.outstanding;
            printf("Found outstanding stats. Sending again.\n");
            this.send();
        } else
            printf("No outstanding stats to fix.\n");
    }

    send_queued() {
        if (this.sending)
            return;
        var data, url, payload;
        if (this.anonymous_queue.q.length && Cookie.list.greenfelt_user) {
            data = this.anonymous_queue.shift();
            data.identify_anonymous = true;
            url = makeurl('play', 'identify', data._play_id, data._anon_key, { user     : Cookie.list.greenfelt_user });
            //printf("Sending previously anonymous stats (%s,%s).\n", data._play_id, data._anon_key);
        } else if (this.queue.length) {
            this.outstanding = data = this.queue.shift();
            //printf("Sending %s stats.\n", Login.is_logged_in() ? "authenticated" : "anonymous");
            url = makeurl('play','create');
            payload = merge(map_obj(function(k,o) {
                                return k.charAt(0) == "_" || o[k] == undefined ? {} : o;
                            }, data),
                            Login && Login.is_logged_in() ? {
                                user    : Login.user
                            } : {});
        } else { // nothing to send
            this.update_status();
            return;
        }

        //print("URL="+url+"\ndata: "+unescape(url)+"\n");

        this.sending = true;
        this.el.classList.add("sending");

        var callback = (result, error, status) => {
            this.el.classList.remove("sending");
            this.sending = false;
            if (result != undefined) {
              data._play_id  = result.play_id;
              data._anon_key = result.anon_key;
              if (result.anon_key) {
                this.anonymous_queue.push(data);
                //printf("Queueing anonymous stats.\n");
                if (Login && Login.is_logged_in())
                    Login.set_error("Please log in again.");
              }
              if (data._callback) data._callback(result.play_id, undefined, result.play);
            } else if (data.identify_anonymous && status == 400) {
                printf("Not requeueing failed identify"); // We keep track of this on the server side now.
            } else { // on failure, requeue and stop trying.
                data.stats_send_retry = (data.stats_send_retry||0)+1;
                if (window.debug)
                    printf("Error sending stats, re-queueing[%d]: %j\n", data.stats_send_retry, error);
                if (data.identify_anonymous)
                    this.anonymous_queue.unshift(data);
                else
                    this.queue.unshift(data);
                delete this.outstanding;
                if (data.stats_send_retry < 10) dom.timeout(250, this.send_queued.bind(this));
                else if (data._callback) data._callback(undefined, "Your game could not be saved. You can click the little card icon in the top right corner to try to save it again. ("+error+")");
                return;
            }
            delete this.outstanding;
            this.update_status();
            this.sent.push(data); // Keep a local log
            this.send_queued(); // Send the next data.
        };
        if (payload)
            postJSON(url, payload, callback);
        else
            loadJSON(url, callback);
    }
}

class Stat {
  constructor(div, stat_name, stats) {
    this.div = div;
    if (div)
        div.appendChild(this.text = document.createTextNode(this.value = 0));
    this.stat_name = stat_name;
    this.stats = stats;
  }
  upd() { return this.stats.set(this.stat_name, this.value); }
  inc(inc) { (this.value += inc); if (this.div) this.text.data = this.value; return this.upd(); }
  set(val) {  this.value  = val;  if (this.div) this.text.data = this.value; return this.upd(); }
  get() { return this.value }
}

module.exports = {
    stats: stats,
    Stat: Stat
};
// Copyright 2005-2014 David Caldwell <david@porkrind.org> All rights reserved.

var Login = require('./login');
var lib = require('./lib'), merge=lib.merge, map_obj=lib.map_obj;
var ajax = require('./ajax'), loadJSON=ajax.loadJSON, postJSON=ajax.postJSON, makeurl=ajax.makeurl;
var print = require('./print'), printf=print.printf;
var dom = require('./dom'), doc=dom.doc, Cookie=dom.Cookie;
var debug = require('./debug'), try_report=debug.try_report, bug=debug.bug, report_error=debug.report_error;

class persistent_queue {
    constructor(name, kb_limit) {
        this.kb_limit = kb_limit;
        this.name = name;
        this.key = "queue_"+name;
        this.q = [];
        this.restore();
    }
    save(ret) {
            try {
                if (!localStorage) return ret;
            } catch(e) {
                return ret;
            }
            let shortq = [].concat(this.q);
            for (var json; (json = JSON.stringify(shortq)).length > this.kb_limit*1024;)
                shortq.shift();
            try {
                localStorage.setItem(this.key, json);
            } catch(e) {
                // safari thows "QuotaExceededError: DOM Exception 22" on .setItem when private browsing (https://stackoverflow.com/questions/21159301/quotaexceedederror-dom-exception-22-an-attempt-was-made-to-add-something-to-st#23453866)
                if (e.code != 22) report_error("persistent_queue-"+this.name+"-save-setItem", e, { shortq:shortq });
            }
            return ret;
    }

    restore() {
            try {
                if (!localStorage) return;
            } catch(e) {
                return;
            }
            var data;
            try_report(() => {
                data = localStorage.getItem(this.key);
            }, "persistent_queue-"+this.name+"-restore-getItem", { key:this.key });
            if (data != null)
                try_report(() => {
                    let d = JSON.parse(data);
                    if (d.constructor != Array) throw new Error("wrong type for queue");
                    this.q = d;
                }, "persistent_queue-"+this.name+"-restore-parse", { key:this.key, data:data });
    }

    push(data)    { return this.save(this.q.push(data)) }
    pop()         { return this.save(this.q.pop()) }
    shift()       { return this.save(this.q.shift()) }
    unshift(data) { return this.save(this.q.unshift(data)) }
}

class stats {
  constructor(game) {
    this.game = game;
    this.queue = [];
    this.anonymous_queue = new persistent_queue("anonymous_plays", 200);
    this.sent = [];
    this.pending_stats = doc.text("");
    doc.id("pending_stats").appendChild(this.pending_stats);
    doc.id("pending").onclick = function () { this.send_queued(); }.bind(this);
    this.pending = doc.id("pending");
    this.el = doc.id("stats");

    if (Login) Login.on_login(function() { this.send_queued() }.bind(this));
  }

    start() {
        this.done();
        this.current = { "name": this.game, "start date": Date.now(), start_timestamp: window.performance.now() };
    }

    cancel() {
        delete this.current;
    }

    started() {
        return this.current && !this.current._done;
    }

    pause() {
        if (this.current && !this.current._pause) {
            this.current._pause = window.performance.now();
            this.inc('pause_count');
        }
    }

    unpause() {
        if (this.current && this.current._pause) {
            this.inc("pause", window.performance.now() - this.current._pause);
            delete this.current._pause;
            this.inc('unpause_count');
        }
    }

    done(callback) {
        if (!this.current) return;
        if (!this.current._done) {
            this.unpause();
            this.current["end date"] = Date.now();
            this.current.end_timestamp = window.performance.now();
            this.current._callback = callback;
            this.current._done = true;
            this.send(this.current);
        } else if (callback) {
            // This strange case happens if you undo your last move and then do it again. Only do the callback if
            // we've got our play_id back by now.
            if (this.current._play_id)
                callback(this.current._play_id);
        }
        this.current = undefined;
    }

    set(stat, val) {
        if (!this.current) return;
        return this.current[stat] = val;
    }

    inc(stat, inc) {
        if (!this.current) return;
        if (inc == undefined) inc = 1;
        if (this.current[stat] == undefined) this.current[stat] = 0;
        return this.current[stat] += inc;
    }

    dec(stat, dec) {
        if (!this.current) return;
        if (dec == undefined) dec = 1;
        if (this.current[stat] == undefined) this.current[stat] = 0;
        return this.current[stat] -= dec;
    }

    max(stat, val) {
        if (!this.current) return;
        if (this.current[stat] == undefined)
            return this.current[stat] = val;
        return this.current[stat] = Math.max(this.current[stat], val);
    }

    min(stat, val) {
        if (!this.current) return;
        if (this.current[stat] == undefined)
            return this.current[stat] = val;
        return this.current[stat] = Math.min(this.current[stat], val);
    }

    push(stat, val) {
        if (!this.current) return;
        if (this.current[stat] == undefined)
            this.current[stat] = [];
        return this.current[stat].push(val);
    }

    save() {
        this.push("save_restore", { save_date: Date.now(), // Not used but seems useful for debugging
                                    save_timestamp: window.performance.now(),
                                    start_timestamp: this.current.start_timestamp }); // start_timestamp is redundant to save, but we do it so we have the history.
        return { ...this.current };
    }

    restore(saved) {
        if (!saved.save_restore || saved.save_restore.length < 1) // Should never happen??
            return;
        this.current = { ...saved };
        let save = this.current.save_restore[this.current.save_restore.length - 1];
        save.restore_date = Date.now(); // Not used (like save_date) but nice when debugging
        this.inc("restore_count");
        // The monotonic timer's origin is not consistent across page loads. So we fake our start to match
        // the current elapsed time (which we compute from what we saved in save())
        this.current.start_timestamp = window.performance.now() - (save.save_timestamp - save.start_timestamp);
    }

    send(data) {
        this.queue.push(data);
        this.update_status();
        this.send_queued();
    }
    update_status () {
        if (this.queue.length) {
            this.el.classList.add("pending");
            this.pending.title = this.queue.length + " game"+(this.queue.length>1?"s":"")+" are waiting to be sent.  Click to send immediately.";
            this.pending_stats.data = this.queue.length;
        } else {
            this.el.classList.remove("pending");
            this.pending_stats.data = "";
        }
    }
    fix() {
        if (this.outstanding) {
            this.sending = false;
            this.queue.unshift(this.outstanding);
            this.outstanding.fixed = (this.outstanding.fixed || 0) + 1;
            delete this.outstanding;
            printf("Found outstanding stats. Sending again.\n");
            this.send();
        } else
            printf("No outstanding stats to fix.\n");
    }

    send_queued() {
        if (this.sending)
            return;
        var data, url, payload;
        if (this.anonymous_queue.q.length && Cookie.list.greenfelt_user) {
            data = this.anonymous_queue.shift();
            data.identify_anonymous = true;
            url = makeurl('play', 'identify', data._play_id, data._anon_key, { user     : Cookie.list.greenfelt_user });
            //printf("Sending previously anonymous stats (%s,%s).\n", data._play_id, data._anon_key);
        } else if (this.queue.length) {
            this.outstanding = data = this.queue.shift();
            //printf("Sending %s stats.\n", Login.is_logged_in() ? "authenticated" : "anonymous");
            url = makeurl('play','create');
            payload = merge(map_obj(function(k,o) {
                                return k.charAt(0) == "_" || o[k] == undefined ? {} : o;
                            }, data),
                            Login && Login.is_logged_in() ? {
                                user    : Login.user
                            } : {});
        } else { // nothing to send
            this.update_status();
            return;
        }

        //print("URL="+url+"\ndata: "+unescape(url)+"\n");

        this.sending = true;
        this.el.classList.add("sending");

        var callback = (result, error, status) => {
            this.el.classList.remove("sending");
            this.sending = false;
            if (result != undefined) {
              data._play_id  = result.play_id;
              data._anon_key = result.anon_key;
              if (result.anon_key) {
                this.anonymous_queue.push(data);
                //printf("Queueing anonymous stats.\n");
                if (Login && Login.is_logged_in())
                    Login.set_error("Please log in again.");
              }
              if (data._callback) data._callback(result.play_id, undefined, result.play);
            } else if (data.identify_anonymous && status == 400) {
                printf("Not requeueing failed identify"); // We keep track of this on the server side now.
            } else { // on failure, requeue and stop trying.
                data.stats_send_retry = (data.stats_send_retry||0)+1;
                if (window.debug)
                    printf("Error sending stats, re-queueing[%d]: %j\n", data.stats_send_retry, error);
                if (data.identify_anonymous)
                    this.anonymous_queue.unshift(data);
                else
                    this.queue.unshift(data);
                delete this.outstanding;
                if (data.stats_send_retry < 10) dom.timeout(250, this.send_queued.bind(this));
                else if (data._callback) data._callback(undefined, "Your game could not be saved. You can click the little card icon in the top right corner to try to save it again. ("+error+")");
                return;
            }
            delete this.outstanding;
            this.update_status();
            this.sent.push(data); // Keep a local log
            this.send_queued(); // Send the next data.
        };
        if (payload)
            postJSON(url, payload, callback);
        else
            loadJSON(url, callback);
    }
}

class Stat {
  constructor(div, stat_name, stats) {
    this.div = div;
    if (div)
        div.appendChild(this.text = document.createTextNode(this.value = 0));
    this.stat_name = stat_name;
    this.stats = stats;
  }
  upd() { return this.stats.set(this.stat_name, this.value); }
  inc(inc) { (this.value += inc); if (this.div) this.text.data = this.value; return this.upd(); }
  set(val) {  this.value  = val;  if (this.div) this.text.data = this.value; return this.upd(); }
  get() { return this.value }
}

module.exports = {
    stats: stats,
    Stat: Stat
};
